"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _users = require("../api/users");

var INITIAL_STATE = [];

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _users.GET_USERS:
      return action.users;
    // case USERS_IN_GROUPS:
    //   return { ...state,
    //     byGroup: {
    //       ...state.byGroup,
    //       [action.group]: action.users
    //     }
    //   };

    default:
      return state;
  }
};

exports["default"] = _default;